import * as React from "react";
function SvgId(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.41 3.67v40.66H0V3.67zm23.06 0q9.39 0 14.46 4.78T48 23a32.8 32.8 0 01-1.14 9.08 17 17 0 01-3.53 6.66 15.28 15.28 0 01-6.09 4.14 24.62 24.62 0 01-8.77 1.42H14.52V3.67zm.45 36.1c.61 0 1.37-.05 2.28-.14a12.65 12.65 0 002.91-.63 13.55 13.55 0 003-1.57 10 10 0 002.7-2.79 15.27 15.27 0 002-4.41 23.34 23.34 0 00.77-6.41 27.47 27.47 0 00-.71-6.52 12.76 12.76 0 00-2.34-4.9 10.25 10.25 0 00-4.18-3.07 16.7 16.7 0 00-6.32-1h-9.1v31.44z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgId);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
